export default __webpack_public_path__ + "static/media/extingaImg_3.72907203.webp";